const _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "75d1e3bb5ab292f807ebeb7ff2e6097f54990a5c"
};